import axios from 'axios';

const PREFIJO="/api/Prv/";

export default {
    provincias() {
        const dto={
            ndt1:process.env.VUE_APP_PAIS_KEY,
            ndt2:process.env.VUE_APP_API_KEY_TIPO
        };
        return axios.post(`${PREFIJO}VmSlPrv`,dto);
    }
};
